import { useEffect } from 'react';
import { KioskIntegration } from '@inter-ikea-gallery/integration';
import { isIkeaApp } from '@inter-ikea-storageone/shared/utils/platform';
import { getCookie, setCookie } from '@inter-ikea-storageone/shared/utils/cookie';
import { getQuery } from '@inter-ikea-storageone/shared/utils/queryUtils';
import { tryParse } from './dataUtils';

export const getKioskIntegration = () => new KioskIntegration();

export const appIntegration = isIkeaApp()
  ? {
      getParameters: () => {
        const query = getQuery();

        const params = {
          cookieConsentOverride: query.get('cookieconsent-override'),
          allowAnalytics: query.get('allow_analytics') === 'true',
          ikeaTheme: query.get('ikea-theme'),
          platform: query.get('platform'),
          testMode: query.get('test-mode') === 'true',
          lc: query.get('lc'),
          cc: query.get('cc'),
          redirectUrl: query.get('redirect_url')
        };

        // eslint-disable-next-line no-console
        console.log('App integration [sendMessage]:', params);

        return params;
      },
      getMessage: () => {
        const appCookie = getCookie('ikeaapp-from-app');

        if (!appCookie) {
          // eslint-disable-next-line no-console
          console.log('No app cookie found');
          return null;
        }

        const data = tryParse<{
          version: number;
          name: string;
          accessToken: string;
          email: string;
          familyCardNumber: string;
          trackingUserPseudoId: string;
          trackingSessionId: number;
        }>(window.atob(appCookie));

        // eslint-disable-next-line no-console
        console.log('[App Integration] Read cookie:', data);

        return data;
      },
      sendMessage: async (
        action: 'forward' | 'backward',
        codes?: { designId: string | null; vpcCode: string | null }
      ) => {
        const { redirectUrl } = appIntegration!.getParameters();

        if (!redirectUrl) return Promise.reject('Could not find URL for IKEA app communication');

        const vpcCode = codes?.vpcCode ?? null;
        const designId = codes?.designId ?? null;

        const message = { action, vpcCode, designId };
        const data = window.btoa(JSON.stringify(message));

        setCookie('ikeaapp-to-app', data);

        window.location.href = redirectUrl;
      }
    }
  : null;

export const useIntegrationInteraction = () => {
  useEffect(() => {
    const kioskIntegration = getKioskIntegration();

    const onInteraction = () => {
      kioskIntegration.userInteraction();
    };

    document.addEventListener('keypress', onInteraction, true);
    document.addEventListener('mousedown', onInteraction, true);
    document.addEventListener('touchstart', onInteraction, true);

    return () => {
      document.removeEventListener('keypress', onInteraction, true);
      document.removeEventListener('mousedown', onInteraction, true);
      document.removeEventListener('touchstart', onInteraction, true);
    };
  }, []);
};
